import { Vue, Options } from 'vue-class-component';
import { PlantType } from '@/../client-generator/generated-clients/plants';
import WizardPlantTypeSelection from './WizardPlantTypeSelection/WizardPlantTypeSelection.vue';
import WizardAutomationPlant from './WizardAutomationPlant/WizardAutomationPlant.vue'
import WizardEntrancePlant from './WizardEntrancePlant/WizardEntrancePlant.vue'
import { ResidentialTypePlant } from '@/core/utils/EntrancePlant/entrance-plant.utils';

enum PlantCreateSteps {
  TYPE_SELECTION,
  WIZARD_AUTOMATION,
  WIZARD_ENTRANCE,
}

@Options({
  name: 'DialogPlantCreate',
  components: {
    WizardPlantTypeSelection,
    WizardAutomationPlant,
    WizardEntrancePlant,
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    editPlantId: {
      type: Number,
      required: false,
    },
    editPlantType: {
      type: Number,
      required: false,
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isVisible: function (newValue) {
      this.isDialogVisible = newValue;
      if (newValue) this.initFormPlant();
    },
  },
  emits: ['hide-dialog', 'plant-edited'],
})
export default class DialogPlantCreate extends Vue {
  isVisible!: boolean;
  editPlantId: number | null = null;
  localPlantId: number | null = this.editPlantId;
  editPlantType: PlantType | null = null;
  isDialogVisible = false;
  isLoading = false;
  isEdit!: boolean;
  PlantCreateSteps = PlantCreateSteps;
  plantCreateSteps: PlantCreateSteps = PlantCreateSteps.TYPE_SELECTION;
  selectedPlantType: PlantType = PlantType.AUTOMATION_PLANT;
  selectedResidentialType: ResidentialTypePlant = ResidentialTypePlant.NEW_PLANT;

  mounted() {
    this.localPlantId = this.editPlantId;
    this.isDialogVisible = this.isVisible;
  }

  initFormPlant() {
    this.localPlantId = this.editPlantId;
    if (this.editPlantId) {
      if (this.editPlantType == PlantType.ENTRANCE_PLANT) {
        this.plantCreateSteps = PlantCreateSteps.WIZARD_ENTRANCE;
      } else {
        this.plantCreateSteps = PlantCreateSteps.WIZARD_AUTOMATION;
      }
    } else {
      if (this.$config.ENTRANCE_PLANT_ENABLED) {
        this.plantCreateSteps = PlantCreateSteps.TYPE_SELECTION;
      } else {
        this.plantCreateSteps = PlantCreateSteps.WIZARD_AUTOMATION;
      }
    }
  }

  handleContinueButton(){
    if (this.selectedPlantType == PlantType.ENTRANCE_PLANT) {
      this.plantCreateSteps = PlantCreateSteps.WIZARD_ENTRANCE;
    } else {
      this.plantCreateSteps = PlantCreateSteps.WIZARD_AUTOMATION;
    }
  }

  updateId(e: number){
    this.localPlantId = e
  }

  handleHideDialog() {
    this.isDialogVisible = false;
  }

  doHideDialog() {
    this.$emit('hide-dialog');
  }

  onPlantEdited() {
    this.isDialogVisible = false;
    this.$emit('plant-edited');
  }

  handleStepLoading(isLoading: boolean) {
    this.isLoading = isLoading;
  }
}
